import React, { Component } from 'react';
import { translate } from 'react-i18next';
import Criterials from '../general/criterials';
import Unit from '../general/unit';
import Options from '../general/options';
import { Typeahead } from 'react-bootstrap-typeahead';
import swal from 'sweetalert';
import { Table, Button } from 'react-bootstrap';
import Inputmask from 'inputmask';
import RaisedButton from 'material-ui/RaisedButton';
import Notifications, { notify } from 'react-notify-toast';
import WaitingModal from '../../generics/WaitingModal';
import moment from 'moment';
import { bin } from 'react-icons-kit/icomoon/bin';
import SvgIcon from 'react-icons-kit';
import ModalReserved from './modalReserved';

var Config = require('../../../config');

class UnsubscribeUnits extends Component {
	constructor(props) {
		super(props);

		this.getOption = this.getOption.bind(this);
		this.getData = this.getData.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onSearch = this.onSearch.bind(this);
		this.onChecked = this.onChecked.bind(this);
		this.selectAll = this.selectAll.bind(this);
		this.onSave = this.onSave.bind(this);
		this.onReturn = this.onReturn.bind(this);
		this.getFolio = this.getFolio.bind(this);
		this.printFolioPDF = this.printFolioPDF.bind(this);
		this.getList = this.getList.bind(this);
		this.selectComponent = this.selectComponent.bind(this);
		this.addUnit = this.addUnit.bind(this);
		this.deleteFromList = this.deleteFromList.bind(this);
		this.discard_units = this.discard_units.bind(this);
		this.getDataForm = this.getDataForm.bind(this);

		this.state = {
			option: "Unit",
			unit_number: "",
			code_component_list: [],
			code_component: "",
			isLoading: false,
			unit_required: false,
			code_required: false,
			component_number: "",
			component_id: "",
			observations: "",
			date: "",
			hour: "",
			units_list: [],
			unit_check: [],
			all_check: false,
			reasons: [],
			reason_id: "",
			folio: "",
			edition: false,
			component: [],
		}
	}

	componentDidMount() {


		this.props.socket.onerror = (event) => {
			console.log(event);
		};

		this.props.socket.onmessage = (event) => {
			var res = JSON.parse(event.data);
			if (res.Error !== undefined) {
				swal('¡Error!', res.Error, 'error');
			}
			console.log(res);
		}



		if (this.props.match.params.folio === undefined) {
			var selector = document.getElementById("hour");
			var im = new Inputmask("--:--");
			im.mask(selector);

			this.getDateHour();


			fetch(Config.default.apiGateway.URL + 'discard_reasons?option=discard_units', {
				method: 'get',
				headers: new Headers({
					'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				})
			})
				.then(res => {
					if (res.ok) {
						return res.json();
					} else {
						res.text().then(function (result) {
							swal('¡Error', result, 'error');
						});
					}
				})
				.then(response => {
					if (response !== undefined) {
						this.setState({ reasons: response });
					}
				});

			this.getFolio();

		} else {
			this.setState({ edition: true });
			this.getList();
		}

	}

	getList() {
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL + 'unit_incidents/by_folio?discard_folio=' +
			this.props.match.params.folio, {
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
			.then(res => {
				this.props.waiting.handleClose();
				if (res.ok) {
					return res.json();
				} else {
					res.text().then(function (result) {
						swal('¡Error', result, 'error');
					});
				}
			})
			.then(response => {
				if (response !== undefined) {
					this.setState({
						units_list: response.res
					})
				}
			});
	}

	getFolio() {
		fetch(Config.default.apiGateway.URL + 'unit_incidents/get_next_folio_discard?health_facilities_id=' + sessionStorage.getItem("health_facilities_id"), {
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
			.then(res => {
				if (res.ok) {
					return res.json();
				} else {
					res.text().then(function (result) {
						swal('¡Error!', result, 'error');
					});
				}
			})
			.then(response => {
				if (response !== undefined) {
					this.setState({ folio: response });
				}
			});
	}

	getDateHour() {
		fetch(Config.default.apiGateway.URL + 'offers?option=date', {
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
			.then(res => {
				if (res.ok) {
					return res.json();
				} else {
					res.text().then(function (result) {
						swal('¡Error', result, 'error');
					});
				}
			})
			.then(response => {
				var aux = response.split('|');

				var hours = this.getHourFormat(aux[1]);

				this.setState({
					date: aux[0].split('/').reverse().join('-'),
					hour: hours,
				});

				document.getElementById('hour').style.borderColor = "#ccc";
				document.getElementById('hour').classList.remove("error");
			});
	}

	getHourFormat(hr) {
		var format = hr.split(' ');
		var hrs = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1] + ' ' + format[2];
		var hour = parseInt(hrs[0], 10);
		var minute = parseInt(hrs[1], 10);

		if ((ampm === "PM" || ampm === "p. m.") && hour < 12) hour += 12;

		if ((ampm === "AM" || ampm === "a. m.") && hour === 12) hour -= 12;

		if (hour < 10) hour = '0' + hour;

		if (minute < 10) minute = '0' + minute;
		var nvaHour = hour + ':' + minute;

		return nvaHour;
	}

	getOption(option) {
		this.setState({
			option: option,
			unit_number: "",
			code_component_list: [],
			code_component: "",
			isLoading: false,
			unit_required: false,
			code_required: false,
			component_number: "",
			component_id: "",
			units_list: [],
			unit_check: [],
			all_check: false,
			reason_id: ""
		});

		this.getDateHour();
	}

	getData(result) {
		var units = [];
		this.setState({
			unit_check: [],
			units_list: [],
			all_check: false,
		});

		setTimeout(function () {
			result.map((d, i) => {
				this.setState({
					unit_check: [...this.state.unit_check, { id: d.unit.id, value: d.unit.volume, check: false }],
				});
				units.push(d);
			});

			this.setState({
				units_list: units,
			});
		}.bind(this), 100);
	}

	handleChange(e) {
		var campo = e.target.name;
		this.setState({
			[campo]: e.target.value
		});

		if (e.target.name === 'hour') {

			var hour = moment(e.target.value, 'h:mm a');

			if (hour.format('H:mm') === "Invalid date" || e.target.value.indexOf('-') !== -1) {
				document.getElementById(e.target.id).classList.add("error");
				document.getElementById(e.target.name).style.borderColor = "red";
			} else {
				document.getElementById(e.target.name).style.borderColor = "#ccc";
				document.getElementById(e.target.id).classList.remove("error");
			}

		} else if (e.target.value !== "") {
			setTimeout(function () {
				this.showCtrlError(campo);
			}.bind(this), 500);
		}
	}

	addUnit(e) {
		if (this.isValidForm()) {
			const selectedIndex = document.getElementById('reason_id').options.selectedIndex;
			var option = document.getElementById('reason_id').options[selectedIndex].text;

			if (this.state.component && this.state.component[0] && !this.state.component[0].sample_result > 0) {
				swal('Error', 'La donación no contiene resultados', 'error');
			}
			else if (this.state.component && this.state.component[0] && this.state.component[0].status === "PENDIENTE DE VALIDAR") {
				swal('Error', 'La donación contiene una unidad pendiente por validar', 'error');
			}

			if (this.state.reason_id !== "") {
				//if(this.state.component[0].status !== 'RESERVADA' && this.state.component[0].status !== 'BLOQUEADA'){
				this.state.component[0].discard_reason = {
					id: parseInt(this.state.reason_id),
					text: option,
					observations: this.state.observations
				}
				this.forceUpdate();

				var index = this.state.units_list.findIndex(obj => obj.unit.id === this.state.component[0].unit.id);

				if (index === -1) {
					this.setState({
						units_list: [...this.state.units_list, this.state.component[0]],
						component: [],
						unit_number: "",
						code_component_list: [],
						observations: "",
						code_component: "",
					});

					this._typeahead.getInstance().clear();

					document.getElementById('reason_id').classList.remove('error');
					document.getElementById('unit_number').focus();

				} else {
					swal('Error', 'La unidad que intenga agregar ya fue agregada a la lista', 'error');
				}

			} else {
				e.preventDefault();
				swal('Error', 'Debe seleccionar un Motivo de Baja', 'error');
			}
		} else {
			swal('Error', 'Campos incompletos', 'error');
		}
	}

	selectComponent(e) {
		if (e.key === 'Enter') {
			this.onSearch(e);

		} else {
			this.onSearch(e);
		}
	}

	onSearch(e) {
		if (e.length > 0) {
			if (e[0].status !== 'BLOQUEADA') {
				this.setState({
					isLoading: true,
					component: e,
					code_component: e[0].label,

				});

				setTimeout(function () {
					this.setState({ isLoading: false });
					document.getElementById('reason_id').focus();
				}.bind(this), 500)
			} else {
				swal('Error', 'El componente que intenta seleccionar se encuentra bloqueado', 'error');
				this._typeahead.getInstance().blur();
				this._typeahead.getInstance().clear();
				this._typeahead.getInstance().focus();
			}


		}
	}

	searchComponent(e) {
		if (e.key === 'Enter') {
			e.preventDefault();

			fetch(Config.default.apiGateway.URL + 'units/get_discard_search?health_facilities_id=' +
				sessionStorage.getItem('health_facilities_id') +
				'&unit_number=' + e.target.value, {
				method: 'get',
				headers: new Headers({
					'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				})
			}).then(res => {
				if (res.ok) {
					return res.json();
				} else {
					res.text().then(msg => {
						swal("Error", msg, 'error')
					});

					document.getElementById('unit_number').focus();
				}
			})
				.then(response => {
					if (response !== undefined) {
						this.setState({
							code_component_list: response,
						});
						this._typeahead.getInstance().clear();
						this._typeahead.getInstance().focus();

					}

				})
		}
	}

	validateInput(e) {
		const re = /^[-+]?$/;

		if (e.key === "Enter") {
			e.preventDefault(); // Prevent form submission if button present

			const form = e.target.form;
			const index = Array.prototype.indexOf.call(form, e.target);

			if (form.elements[index + 1] !== undefined)
				form.elements[index + 1].focus();

			if (!re.test(e.key)) {
				e.preventDefault();
			}
		}
	}

	onChecked(e) {
		this.state.unit_check.map((u, j) => {
			return u.id === parseInt(e.target.id) ?
				u.check = u.check ? false : true
				: null
		});
		this.forceUpdate();
	}

	selectAll(e) {
		if (e.target.checked) {
			this.setState({
				all_check: true
			})
		} else {
			this.setState({
				all_check: false
			})
		}

		this.state.unit_check.map((u, j) => {
			if (e.target.checked)
				u.check = true;
			else
				u.check = false;

		});
		this.forceUpdate();
	}

	onSave() {
		if (this.isValidDate(this.state.date)) {

			if (this.state.option !== 'Unit' ? this.isValidForm() : true) {
				var incidents = this.getDataForm();

				if (incidents.units.length === 0) {
					swal('¡Error!', "No ha seleccionado ninguna unidad", 'error');
				} else if (incidents.units[0].hour === "Invalid date") {
					notify.show("Error, Hora invalida", 'error');

				} else if (incidents.locked !== '') {
					swal('Error', 'No es posible guardar las unidades ' + incidents.locked + ' debido a que se encuentran bloqueadas', 'error');

				}/*else if(incidents.reserved !== ''){
					swal('Error', 'No es posible guardar las unidades '+incidents.reserved+' debido a que se encuentran reservadas', 'error');
				
				}*/else {

					this.discard_units(incidents.units)
				}

			} else {
				swal('¡Error!', "Campos incompletos", 'error');
			}
		} else {
			notify.show('Error, Fecha no válida', 'error');
		}
	}

	discard_units(units) {
		this.waiting_modal.handleShow('Guardando...');
		fetch(Config.default.apiGateway.URL + 'unit_incidents', {
			method: "POST",
			body: JSON.stringify(units),
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			})
		}).then(res => {
			this.waiting_modal.handleClose();
			if (res.ok) {
				return res.json();
			} else {
				res.text().then(function (msg) {
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if (response !== undefined) {
				if (response.length > 0) {
					this.modal_reserved.handleShow(response);
				} else {
					swal('¡Buen Trabajo!', "Proceso Terminado", 'success');

					if (this.state.option !== 'Unit') {
						//Limpiar componente seleccionado
						this.criterials.setState({ blood_component_id: "all" });
						//Recargar componentes
						this.criterials.getBloodComponent('lookups?type=blood_component_type&option=actives&order=true');

					} else {
						this._typeahead.getInstance().clear();
					}
					this.printFolioPDF(this.state.folio);

					this.setState({
						unit_number: "",
						code_component_list: [],
						code_component: "",
						isLoading: false,
						unit_required: false,
						code_required: false,
						component_number: "",
						component_id: "",
						date: "",
						hour: "",
						units_list: [],
						unit_check: [],
						all_check: false,
						reason_id: ""
					});
					this.getFolio();

					this.onReturn();
				}

			}
		});
	}

	async printFolioPDF(folio) {
		this.props.waiting.handleShow('Imprimiendo...');

		var obj = {};
		obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"), 10);
		obj.id = folio;
		obj.file_type = "discard_units";
		obj.nEtiqueta = [0];

		var type = await this.props.getDocumentType(obj.file_type);

		var document;
		if (type.print_type === 'template') {
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		} else if (type.print_type === 'external') {
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		}

		this.props.waiting.handleClose();



	}

	directPrint(response, label_type) {
		//PRINTER
		var reader = new FileReader();
		reader.readAsDataURL(response);
		reader.onloadend = () => {
			var base64data = reader.result;
			var aux = base64data.split(',');
			this.props.socket.send('{"Operacion":"print", "Type":"' + label_type + '", "File": "' + aux[1] + '"}');
		}
	}

	getDataForm() {
		var obj = {};
		var date = moment(this.state.date.split('-').reverse().join('/'), 'DD-MM-YYYY');
		var hour = moment(this.state.hour, 'h:mm a');
		var unit_reserved = '';
		var unit_locked = '';

		var units = [];

		this.state.units_list.map((u, i) => {
			if (this.state.option === "Unit") {
				units.push({
					unit_id: u.unit.id,
					discard_reason_id: parseInt(u.discard_reason.id),
					date: date.format('MM-DD-YYYY'),
					hour: this.state.hour.indexOf('-') !== -1 ? "Invalid date" : hour.format('H:mm'),
					observations: u.discard_reason.observations
				});

			} else {
				if (this.state.unit_check[i].check) {
					if (u.status === 'RESERVADA') {
						unit_reserved += u.unit.unit_number + ' ' +
							(u.component_number !== undefined ? u.component_number
								: u.unit.component_number) + ', ';
					}

					if (u.status === 'BLOQUEADA') {
						unit_locked += u.unit.unit_number + ' ' +
							(u.component_number !== undefined ? u.component_number
								: u.unit.component_number) + ', ';
					}

					units.push({
						unit_id: u.unit.id,
						discard_reason_id: parseInt(this.state.reason_id),
						date: date.format('MM-DD-YYYY'),
						hour: this.state.hour.indexOf('-') !== -1 ? "Invalid date" : hour.format('H:mm'),
						observations: this.state.observations
					});

				}
			}

		});

		obj = { units: units, reserved: unit_reserved, locked: unit_locked };

		return obj;
	}

	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
		let isFormValid = true;


		inputs.forEach(input => {
			if (input.required) {

				const isInputValid = this.showCtrlError(input.name);
				if (!isInputValid) {
					isFormValid = false;
				}
			}
		});



		return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);

		if (this.state[refName] === "") {
			if (control !== null) {
				control.classList.add('error');
			}
			res = false;
		} else {
			if (control !== null) {
				if (control.required && control.className.includes('error')) {
					control.classList.remove('error');
				}
			}
			res = true;
		}

		return res;
	}

	onReturn() {
		this.props.history.push('/discard_units_list');
	}

	isValidDate(fecha) {
		var valid = moment(fecha).format('MM-DD-YYYY');

		if (valid === 'Invalid date') {
			return false;
		} else {
			return true;
		}
	}

	onDelete(id) {
		swal({
			title: '¿Está seguro?',
			text: '¿Desea eliminar este registro?',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#DD6B55',
			confirmButtonText: '¡Si, Eliminar!',
			cancelButtonText: '¡No, Cancelar!',
			closeOnConfirm: true,
			closeOnCancel: true
		}, function (isConfirm) {
			if (isConfirm) {
				this.props.waiting.handleShow('Eliminando...');
				fetch(Config.default.apiGateway.URL + 'unit_incidents/delete_unit?unit_id=' + id, {
					method: 'delete',
					headers: new Headers({
						'Authorization': 'Bearer ' + sessionStorage.getItem('token'),
						'Accept': 'application/json',
						'Content-Type': 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if (res.ok) {
						return res.json();
					} else {
						res.text().then((msg) => {
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if (response !== undefined) {
						this.getList();
						swal('Correcto', 'El registro se elimino correctamente.', 'success');
					}
				})
			}
		}.bind(this));
	}

	deleteFromList(i) {
		var array = [...this.state.units_list];
		array.splice(i, 1);
		this.setState({ units_list: array });
	}

	render() {
		const { t } = this.props;
		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} ->
						{t('sidebar.nav.process.MAIN')} ->
						{t('sidebar.nav.process.units.MAIN')}
					</h5>
				</div>

				<form noValidate>
					<div className="col-xs-12">

						{!this.state.edition ?
							<fieldset>
								<legend style={{ fontSize: "1.5em", marginBottom: "5px" }}>Búsqueda</legend>
								<div className="col-xs-12 col-sm-1" style={{ paddingRight: "0" }}>
									<Options {...this.props} validate={this.validateInput} sendData={this.getOption}
										onRef={ref => (this.options = ref)} />
								</div>

								<div className="col-xs-12 col-sm-10">
									{this.state.option === 'Block' ?
										<Criterials {...this.props} search={""} validate={this.validateInput} sendData={this.getData} onRef={ref => (this.criterials = ref)} />
										:
										<div className="col-xs-12">
											<div className="col-xs-12 col-sm-3 col-md-2" >
												<span className="span-min">Número de Unidad</span>
												<input type="text" name="unit_number" id="unit_number"
													onChange={this.handleChange} value={this.state.unit_number || ""}
													onKeyPress={(e) => this.searchComponent(e)}
													required
													className={this.state.unit_required ? "form-control error" : "form-control"} />
											</div>

											<div className="col-xs-12 col-sm-3 col-md-2" >
												<span className="span-min">Código Componente</span>

												<Typeahead
													/*{...this.state}*/
													labelKey={(option) => `${option.label}`}
													minLength={0}
													options={this.state.code_component_list}
													onKeyDown={this.selectComponent}
													onChange={this.onSearch}
													inputProps={{
														name: "code_component",
														required: 'required',
														id: "code_component"
													}}
													id="codeComponent"
													selectHintOnEnter={true}
													isLoading={this.state.isLoading}
													ref={ref => this._typeahead = ref}
													delay={600}
													paginationText="Mostrar mas resultados..."
												/>
											</div>
											<div className="col-xs-12 col-sm-3 col-md-2">
												<span>Motivo de Baja</span>
												<select name="reason_id" id="reason_id" className="form-control" value={this.state.reason_id || ""}
													onChange={this.handleChange} required>
													<option value="">Seleccione...</option>
													{this.state.reasons.map((r, i) => {
														return <option key={i} value={r.id}>
															{r.name}
														</option>
													})}
												</select>
											</div>
											<div className="col-xs-12 col-sm-3 col-md-4">
												<span>Observaciones</span>
												<input type="text" name="observations" id="observations"
													onChange={this.handleChange} value={this.state.observations}
													maxLength="250" className="form-control" />
											</div>
											<div className="col-xs-12 col-sm-1" >
												<button type="button" className="btn btn-info" style={{ fontSize: "0.8em", marginTop: "16px" }}
													onClick={this.addUnit}>
													Agregar
												</button>
											</div>
										</div>
									}
								</div>
							</fieldset>
							: null}


						<fieldset>
							{!this.state.edition ?
								<legend style={{ fontSize: "1.5em", marginBottom: "5px" }}>Proceso</legend>
								: null}

							{!this.state.edition ?
								<div className="col-xs-12 form-group">
									<div className="col-xs-12 col-sm-offset-1" style={{ width: "14.2%" }}>
										<span>Fecha</span>
									</div>
									<div className="col-xs-12 col-sm-2" style={{ width: "14%" }}>
										<input className="form-control" name="date" id="date" type="date" value={this.state.date || ""}
											onChange={this.handleChange} ref={(input) => { this.inputRef = input }} onKeyPress={(e) => this.validateInput(e)} required />
									</div>
									<div className="col-xs-12 col-sm-1" style={{ width: "7.33%" }}>
										<span>Hora</span>
									</div>
									<div className="col-xs-12 col-sm-1" style={{ width: "14%" }}>
										<input id="hour" name="hour" type="text" data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"
											data-inputmask-placeholder="-" value={this.state.hour || ""} onChange={this.handleChange}
											required onKeyPress={(e) => this.validateInput(e)} className="form-control" />
									</div>
								</div>
								: null}

							{!this.state.edition ?
								<>
									<div className="col-xs-12 form-group">
										<div className="col-xs-12 col-sm-2 col-sm-offset-1" style={{ width: "14.2%" }}>
											<span>Folio</span>
										</div>
										<div className="col-xs-12 col-sm-2" style={{ width: "14%" }}>
											<input type="text" disabled value={this.state.folio} className="form-control" />
										</div>
										{this.state.option !== 'Unit' ?
											<div className="col-xs-12 col-sm-2" style={{ width: "7.33%" }}>
												<span>Motivo de Baja</span>
											</div>
											: null}
										{this.state.option !== 'Unit' ?
											<div className="col-xs-12 col-sm-2" style={{ width: "14%" }}>
												<select name="reason_id" id="reason_id" className="form-control" value={this.state.reason_id || ""}
													onChange={this.handleChange} required>
													<option value="">Seleccione...</option>
													{this.state.reasons.map((r, i) => {
														return <option key={i} value={r.id}>
															{r.name}
														</option>
													})}
												</select>
											</div>
											: null}
									</div>
									<div className='col-xs-12 form-group'>
										{this.state.option !== 'Unit' ?
											<div className="col-xs-12 col-sm-2 col-sm-offset-1" style={{ width: "14.2%" }}>
												<span>Observaciones</span>
											</div>
											: null}
										{this.state.option !== 'Unit' ?
											<div className="col-xs-12 col-sm-10" style={{ width: "35.33%" }}>
												<input name="observations" id="observations" className="form-control" value={this.state.observations || ""}
													onChange={this.handleChange} required />
											</div>
											: null}
									</div>
								</>
								: null}

							<div className="col-xs-12 col-sm-10 col-sm-offset-1 form-group">
								{this.state.option !== 'Unit' && !this.state.edition ?
									<div className="col-xs-12 col-sm-9">
										<input className="form-check-input" name="all" type="checkbox" type="checkbox" onKeyPress={(e) => this.validateInput(e)}
											checked={this.state.all_check} onChange={this.selectAll} />
										<span className="span-min" style={{ paddingLeft: "5px" }}>Seleccionar Todos</span>
									</div>
									: null}
								<div className="col-xs-12 ">
									<Table responsive hover>
										<thead>
											<tr>
												<th hidden={this.state.edition}></th>
												<th>No. Unidad</th>
												<th>No. Componente</th>
												<th>Fecha Caducidad</th>
												<th>Componente Sanguíneo</th>
												<th>Grupo y RH</th>
												<th>Volumen</th>
												<th hidden={this.state.option !== 'Unit'}>Motivo de Baja</th>
												<th>
													{!this.state.edition ? "Estatus" : ""}
												</th>
												<th hidden={!this.state.edition ? this.state.option !== 'Unit' : true}></th>

											</tr>
										</thead>
										<tbody>

											{this.state.units_list.length > 0 ?
												this.state.units_list.map((d, i) => {
													return <tr key={i}>
														<td hidden={this.state.edition}>
															{this.state.option !== "Unit" ?
																<input type="checkbox" id={d.unit.id} onChange={this.onChecked}
																	onKeyPress={(e) => this.validateInput(e)}
																	checked={this.state.unit_check[i] !== undefined ? this.state.unit_check[i].check : ""}
																	value={this.state.unit_check[i] !== undefined ? this.state.unit_check[i].value : ""} />
																: null}
														</td>
														<td>{d.unit.unit_number}</td>
														<td>{d.component_number !== undefined ? d.component_number : d.unit.component_number}</td>
														<td>{moment(d.unit.caducidad).format('DD/MM/YYYY')}</td>
														<td>
															{d.blood_component !== undefined ?
																d.blood_component.component
																: d.component}
														</td>
														<td>{d.unit.group + (d.unit.rh === "POSITIVO" ? '+' : '-')}</td>
														<td>{d.unit.volume} ml</td>
														<td hidden={this.state.option !== 'Unit'}>
															{this.state.option !== 'Unit' ? '' :
																this.state.edition ?
																	d.incident
																	: d.discard_reason.text
															}

														</td>
														<td>
															{!this.state.edition ? d.status :
																<Button className="btn btn-info btn-xs" title="Eliminar"
																	style={{ marginRight: '3px' }}
																	onClick={this.onDelete.bind(this, d.unit.id)}>
																	<SvgIcon icon={bin} style={{ paddingTop: "3px" }} />
																</Button>
															}
														</td>
														<td hidden={!this.state.edition ? this.state.option !== 'Unit' : true}>
															<Button className="btn btn-info btn-xs" title="Eliminar"
																style={{ marginRight: '3px' }}
																onClick={this.deleteFromList.bind(this, i)}>
																<SvgIcon icon={bin} style={{ paddingTop: "3px" }} />
															</Button>
														</td>
													</tr>
												})
												: null}
										</tbody>
									</Table>
								</div>
							</div>



						</fieldset>

						<div className="col-xs-12" style={{ textAlign: 'center' }}>
							{!this.state.edition ?
								<div>
									<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} style={{ margin: 12 }} onClick={this.onSave} />
									<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} style={{ margin: 12 }} onClick={this.onReturn} />
								</div>
								: <div>
									<RaisedButton className="action-btn" label={t('content.generics.buttons.finish')} primary={true} style={{ margin: 12 }} onClick={this.onReturn} />
								</div>}
						</div>

						<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)} />
						<ModalReserved {...this.props} onRef={ref => (this.modal_reserved = ref)} discard={this.discard_units} getDataForm={this.getDataForm} />
						<Notifications />
					</div>
				</form>

			</div>
		)
	}
}

export default translate('translations')(UnsubscribeUnits)